import React from "react";

import "../css/TablaIVA.css";

const CAMPOS_IVA = [
  { key: "audifonos", label: "Audífonos" },
  { key: "cristales", label: "Lentes" },
  { key: "lentillas", label: "L. contacto" },
  { key: "liquidos", label: "Líquidos" },
  { key: "monturas", label: "Monturas" },
  { key: "varios", label: "Varios" },
  { key: "sol", label: "Sol" },
  { key: "superreducido", label: "Superreducido" },
  { key: "reducido", label: "Reducido" },
  { key: "normal", label: "Normal" },
  { key: "reSuperreducido", label: "RE superreducido" },
  { key: "reReducido", label: "RE reducido" },
  { key: "reNormal", label: "RE normal" },
];

export default function TablaIVA({ iva }) {
  if (!iva) return null;

  return (
    <div className="iva-table-container">
      <table className="settings-iva-table">
        <tbody>
          {/* Fila 1: conceptos */}
          <tr>
            {CAMPOS_IVA.map((campo) => (
              <td key={campo.key}>{campo.label}</td>
            ))}
          </tr>

          {/* Fila 2: valores */}
          <tr>
            {CAMPOS_IVA.map((campo) => (
              <td key={campo.key}>{iva[campo.key]}%</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
